export interface ConsultaMargemPayload {
  callback: () => void
  errorCallback?: (errorCode?: string) => void
  selectedContracts?: string[]
  convenioName: string
  salary?: number
}

export enum MarginAcceptApiErrorCodes {
  // Indisponibilidade temporária por processamento da virada de competência
  PROCESSAMENTO_VIRADA_COMPETENCIA = 'MA0007',
}

export interface MarginAcceptApiError {
  message?: string
  additionalMessage?: string
}

export interface MarginAcceptApiErrorResponse {
  errors?: MarginAcceptApiError[]
}

export interface MarginAcceptResultState {
  readonly loading: boolean
  readonly error: boolean
  readonly consultaMargemRealizada: boolean
}

export interface ConsultaMargemBasePayload {
  callback: () => void
  callbackError?: () => void
}

export interface ConsultaMargemResultPayload {
  callback: (code: string) => void
  convenioName: string
}

export interface MarginApiResponse {
  code: string
}

export enum ConsultaMargemTypes {
  CONSULTA_MARGEM_ACCEPT_REQUEST = '@refinanciamento/consultaMargem/CONSULTA_MARGEM_ACCEPT_REQUEST',
  CONSULTA_MARGEM_ACCEPT_SUCCESS = '@refinanciamento/consultaMargem/CONSULTA_MARGEM_ACCEPT_SUCCESS',
  CONSULTA_MARGEM_ACCEPT_ERROR = '@refinanciamento/consultaMargem/CONSULTA_MARGEM_ACCEPT_ERROR',
  CONSULTA_MARGEM_RESULT_REQUEST = '@refinanciamento/consultaMargem/CONSULTA_MARGEM_RESULT_REQUEST',
  CONSULTA_MARGEM_RESULT_SUCCESS = '@refinanciamento/consultaMargem/CONSULTA_MARGEM_RESULT_SUCCESS',
  CONSULTA_MARGEM_RESULT_ERROR = '@refinanciamento/consultaMargem/CONSULTA_MARGEM_RESULT_ERROR',
  CONSULTA_MARGEM_RESET = '@refinanciamento/consultaMargem/CONSULTA_MARGEM_RESET',
}
